<script lang="ts">
import { defineComponent } from 'vue';
import SolutoButton from '../../components/SolutoButton.vue';
import router from '../../router';
import { mapActions } from 'vuex';
export default defineComponent({
  name: 'Tutorial',
  components: {
    Button: SolutoButton
  },
  mounted () {
    const pic = window.document.getElementById('pic');
    if (pic) {
      pic.style.height = pic.offsetWidth * 0.75 + 'px';
      this.$emit('scroll');
      this.$emit('load');
    }
  },
  methods: {
    ...mapActions([
      'changeLevel',
      'sawAnswer'
    ]),
    gotoLevel1 () {
      router.push({ path: '/interactive/rule-of-third/level' });
      this.changeLevel(1);
    }
  }
});
</script>

<template>
  <div class="interactive-body">
    <img class="interactive-gif" id="pic" src="../../assets/interactive/tutorial.gif"/>
    <div class="interactive-text">
      {{ $t('tutorial_text') }}
    </div>
    <div class="interactive-footer">
      <Button
        :size="'large'"
        :text="$t('challenge-level1')"
        @click="gotoLevel1()"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tutorial {
  display: flex;
  flex-direction: column;
}
.interactive-gif {
  width: 100%;
}
</style>
